import React, { useRef, useEffect, useState } from "react";
import { actionByID } from "../../Model/Auction";
import Lot from "./Lot";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Banner from "./Banner";
import {encodeId, decodeId} from "../../hash";
import { useParams } from "react-router-dom";




const View = () => {
    
  const hasRun = useRef(false); // holds whether function ran or not

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  var { id } = useParams();
  const [showHp, setShowHp] = useState(null);
  const FetchBanner =  () => {
    setLoading(true);
    async function getBanner() {

 

      const results = await actionByID(decodeId(id));
      setData(results)

      setShowHp(results[0].showHp)

      
    }
    getBanner().catch(console.error);
  };

  useEffect(() => {
  
    if (!hasRun.current) {
      FetchBanner();
      hasRun.current = true; // set it so it won't run again
    }


  }, [id,data,showHp]);



  return (
    <div>
      <Banner  data={data} /> <Lot showHp={showHp} />
    </div>
  );
};

export default React.memo(View);
